import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSC: CultureInfo = {
  name: 'en-SC',
  displayName: 'English (Seychelles)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SC',
  parent: CultureInfoEn
};
